import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import typographySemantic from '../design-tokens/typography-semantic.json';
var FONT_WEIGHT_MAP = {
  Black: 900,
  ExtraBold: 800,
  Bold: 700,
  Semibold: 600,
  Medium: 500,
  Regular: 400,
  Light: 300,
  Thin: 200,
  Hairline: 100
};
var GENERIC_FALLBACK_STACK = 'helvetica, arial, sans-serif';
var DEFAULT_FONT_FAMILY = "Proxima Nova Sans, ".concat(GENERIC_FALLBACK_STACK);
var toPx = value => typeof value === 'number' ? "".concat(value, "px") : value;
export var toLineHeight = token => {
  var _token$unit;
  if (typeof token === 'string' || typeof token === 'number') {
    return toPx(token);
  }
  if (typeof token.value !== 'number') {
    return 'normal';
  }
  var unit = (_token$unit = token.unit) === null || _token$unit === void 0 ? void 0 : _token$unit.toLowerCase();
  switch (unit) {
    case 'percent':
      return "".concat(token.value / 100);
    case 'em':
    case 'rem':
      return "".concat(token.value).concat(unit);
    case 'px':
    case 'pixel':
    default:
      return "".concat(token.value, "px");
  }
};
export var toLetterSpacing = token => {
  var _token$unit2;
  if (!token || typeof token.value !== 'number') {
    return undefined;
  }
  var unit = (_token$unit2 = token.unit) === null || _token$unit2 === void 0 ? void 0 : _token$unit2.toLowerCase();
  switch (unit) {
    case 'percent':
      return "".concat(token.value / 100, "em");
    case 'em':
    case 'rem':
      return "".concat(token.value).concat(unit);
    case 'px':
    case 'pixel':
    default:
      return "".concat(token.value, "px");
  }
};
export var mapFontWeight = fontWeight => {
  var _FONT_WEIGHT_MAP$font;
  if (typeof fontWeight === 'number') {
    return fontWeight;
  }
  return (_FONT_WEIGHT_MAP$font = FONT_WEIGHT_MAP[fontWeight]) !== null && _FONT_WEIGHT_MAP$font !== void 0 ? _FONT_WEIGHT_MAP$font : 400;
};
export var mapFontFamily = fontFamily => {
  var _fontFamily$split$;
  var primaryFont = (_fontFamily$split$ = fontFamily.split(',')[0]) === null || _fontFamily$split$ === void 0 ? void 0 : _fontFamily$split$.trim();
  if (!primaryFont || primaryFont.toLowerCase() === 'proxima nova') {
    return DEFAULT_FONT_FAMILY;
  }
  return "".concat(primaryFont, ", ").concat(GENERIC_FALLBACK_STACK);
};
export var mapTextTransform = textCase => {
  var normalizedTextCase = textCase === null || textCase === void 0 ? void 0 : textCase.toLowerCase();
  switch (normalizedTextCase) {
    case 'uppercase':
      return 'uppercase';
    case 'lowercase':
      return 'lowercase';
    case 'capitalize':
      return 'capitalize';
    case 'original':
    default:
      return 'none';
  }
};
var aliases = typographySemantic.typography;
export var semanticTextStyles = Object.entries(aliases).reduce((accumulator, _ref) => {
  var _ref2 = _slicedToArray(_ref, 2),
    alias = _ref2[0],
    token = _ref2[1];
  accumulator[alias] = {
    fontFamily: mapFontFamily(token.fontFamily),
    fontWeight: mapFontWeight(token.fontWeight),
    fontSize: toPx(token.fontSize),
    lineHeight: toLineHeight(token.lineHeight),
    letterSpacing: toLetterSpacing(token.letterSpacing),
    textTransform: mapTextTransform(token.textCase)
  };
  return accumulator;
}, {});